import React, { useState, useEffect, useRef, useMemo } from 'react';
import { PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis, Legend, ResponsiveContainer, Line, LineChart } from 'recharts';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import SortableTree from 'react-sortable-tree';

import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import uniqid from 'uniqid';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
import { icon } from '../../../WEBContent/Icon';
import { color } from '../../../WEBContent/Color';

import {
    reqGET,
    reqPOST,
    reqDELETE,
    reqPUT,
    reqFILE,
    content_language,
    translate,
    functionSendMail,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';

export default function List(props) {
    const [, set_dados] = useState(null);
    const dados = useRef(null);

    const type_active = useRef(null);
    const types_actives = useRef(null);
    const year_active = useRef(null);
    const years_actives = useRef(null);

    const entities_list = useRef(null);
    const entities_list_external = useRef(null);
    const active = useRef(null);
    const active_raw = useRef(null);
    const repair_type = useRef(null);
    const periodicity = useRef(null);
    const priority = useRef(null);

    const [lang, set_lang] = useState('pt');
    const [uid,] = useState(uniqid());

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);
    const [refresh, setRefresh] = useState(0);

    const [show_delete_button, set_show_delete_button] = useState(false);

    //const [disabled, set_disabled] = useState(true)

    const [is_edit, set_is_edit] = useState(false)
    const [treeDataPDF, setTreeDataPDF] = useState([])
    const [treeDataEditable, setTreeDataEditable] = useState([])

    const [files_doc_pdf, set_files_doc_pdf] = useState([]);
    const [files_doc_pdf_name, set_files_doc_pdf_name] = useState([]);
    const [files_doc_editable, set_files_doc_editable] = useState([]);
    const [files_doc_editable_name, set_files_doc_editable_name] = useState([]);

    const [treeDataImage, setTreeDataImage] = useState([])
    const [files_doc_image, set_files_doc_image] = useState([]);
    const [files_doc_image_name, set_files_doc_image_name] = useState([]);

    const [notify_responsable_edit, set_notify_responsable_edit] = useState(false)
    const [notify_responsable_aproval, set_notify_responsable_aproval] = useState(false)
    const [notify_responsable_remove, set_notify_responsable_remove] = useState(false)

    const [document_state_list, set_document_state_list] = useState([])
    const [document_state_aprove, set_document_state_aprove] = useState(false)

    const [selectedEquipment, setSelectedEquipment] = useState(null);
    const [manutencao, setManutencao] = useState(null); //TRUE = 'Manutenção', FALSE = 'Reparação', NULL = 'Nenhum'
    const [externalIntervention, setExternalIntervention] = useState('');

    // Energy Type
    const energy_type = useRef([]);
    const allEnergyTypes = useRef([]);

    const [selectedEnergyTypes, setSelectedEnergyTypes] = useState([]);
    const [modalEnergyType, setModalEnergyType] = useState(false);
    const [selectedEnergyTypeId, setSelectedEnergyTypeId] = useState(energy_type.current[0]?.id || null);
    const [consumeInput, setConsumeInput] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [dataInput, setDataInput] = useState('');
    const [periodoInput, setPeriodoInput] = useState('');
    const [custoInput, setCustoInput] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editItemId, setEditItemId] = useState(null);

    const [showTables, setShowTables] = useState(true);
    const [showGraphs, setShowGraphs] = useState(false);
    const [showConversions, setShowConversions] = useState(false);

    // Filter states
    const [filterMonth, setFilterMonth] = useState('');
    const [filterYear, setFilterYear] = useState('');
    const [filterEnergyType, setFilterEnergyType] = useState('');

    const filteredEnergyTypes = selectedEnergyTypes.filter(item => {
        const itemDate = new Date(item.data);
        const itemMonth = itemDate.getMonth() + 1;
        const itemYear = itemDate.getFullYear();

        const matchMonth = filterMonth ? parseInt(filterMonth) === itemMonth : true;
        const matchYear = filterYear ? parseInt(filterYear) === itemYear : true;
        const matchEnergyType = filterEnergyType ? String(item.id) === String(filterEnergyType) : true;

        return matchMonth && matchYear && matchEnergyType;
    });

    const MONTH_NAMES = [
        language[lang].janeiro,
        language[lang].fevereiro,
        language[lang].marco,
        language[lang].abril,
        language[lang].maio,
        language[lang].junho,
        language[lang].julho,
        language[lang].agosto,
        language[lang].setembro,
        language[lang].outubro,
        language[lang].novembro,
        language[lang].dezembro
    ];

    const selectedMonthName = filterMonth ? MONTH_NAMES[parseInt(filterMonth) - 1] : '';

    ////////////////////////////////////////////////////////////////////////////////////////

    const conversionTable = {
    
        kg: { factor: 0.001, target: 't' },  
        t: { factor: 0.7, target: 'tep' },    

        kWh: { factor: 0.0000859845, target: 'tep' },
        kWp: { factor: 0.112, target: 'tep' },   
        'm³': { factor: 0.000857, target: 'tep' },
        L: { factor: 0.00085, target: 'tep' },
        gal: { factor: 0.003, target: 'tep' },

        g: { factor: 0.000001, target: 'kg' }, 
        mg: { factor: 0.000001, target: 'g' },  
        ml: { factor: 0.001, target: 'L' },     

        W: { factor: 0.001, target: 'kW' },   
        kW: { factor: 0.0000859845, target: 'tep' },
       
        A: { factor: 1, target: 'tep' },
        V: { factor: 1, target: 'tep' },
        cm: { factor: 0.01, target: 'm' },
        mm: { factor: 0.001, target: 'm' },
        m: { factor: 1, target: 'm' },
        un: { factor: 1, target: 'un' },
        pc: { factor: 1, target: 'un' },
        par: { factor: 2, target: 'un' },
        pct: { factor: 0.01, target: 'un' } 
        
    };

    const fuelSpecificConversions = {
        diesel: {
            t: { factor: 1.01, target: 'tep' },
            'm³': { factor: 0.98, target: 'tep' },
        },
        gasolina: {
            t: { factor: 1.05, target: 'tep' },
            'm³': { factor: 0.86, target: 'tep' },
        },
        biodiesel: {
            t: { factor: 0.86, target: 'tep' },
            'm³': { factor: 0.78, target: 'tep' },
        },
        bioetanol: {
            t: { factor: 0.64, target: 'tep' },
            'm³': { factor: 0.51, target: 'tep' },
        },
    };

    function capitalize(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function parseCost(cost) {
        if (!cost) return 0;

        const normalized = String(cost)
            .replace(/[^\d.,]/g, '')
            .replace(',', '.');

        const parsed = parseFloat(normalized);
        return isNaN(parsed) ? 0 : parsed;
    }

    const tepByUnit = {};

    filteredEnergyTypes.forEach((item) => {
        const unit = item.unidade?.trim();
        const conversion = conversionTable[unit];
        const consume = parseCost(item.consume);

        if (conversion) {
            const convertedTEP = consume * conversion.factor;

            if (!tepByUnit[unit]) {
                tepByUnit[unit] = {
                    totalTEP: 0,
                    targetUnit: conversion.target,
                    conversionFactor: conversion.factor,
                };
            }

            tepByUnit[unit].totalTEP += convertedTEP;
        }
    });

    const years = Array.from(
        new Set(
            filteredEnergyTypes.map((item) => {
                if (!item.periodo) return null;
                return new Date(item.periodo).getFullYear();
            }).filter(Boolean)
        )
    ).sort();

    const months = Array.from(
        new Set(
            filteredEnergyTypes
                .filter(item => item.periodo)
                .map(item => {
                    const date = new Date(item.periodo);
                    return new Date(date.getFullYear(), date.getMonth(), 1).toISOString();
                })
        )
    )
        .map(iso => new Date(iso))
        .sort((a, b) => a - b)
        .map(date =>
            date.toLocaleString('pt-PT', { month: 'long', year: 'numeric' })
        );

    ////////////////////////////////////////////////////////////////////////////////////////

    const energyLabels = Array.from(
        new Set(filteredEnergyTypes.map((item) => item.label))
    );
    const energyIs = Array.from(
        new Set(filteredEnergyTypes.map((item) => item.id))
    );

    const monthlyDataByType = useMemo(() => {
        const consumeResult = {};
        const custoIvaResult = {};

        filteredEnergyTypes.forEach(item => {
            const date = new Date(item.data);
            const year = date.getFullYear();
            const month = date.getMonth();
            const key = `${year}-${String(month + 1).padStart(2, '0')}`;
            const monthLabel = `${MONTH_NAMES[month]} ${year}`;

            const energyName = item.name || 'Unknown';

            if (!consumeResult[key]) consumeResult[key] = { date: key, label: monthLabel };
            if (!custoIvaResult[key]) custoIvaResult[key] = { date: key, label: monthLabel };

            consumeResult[key][energyName] =
                (consumeResult[key][energyName] || 0) + parseCost(item.consume);
            custoIvaResult[key][energyName] =
                (custoIvaResult[key][energyName] || 0) + parseCost(item.custo_iva);
        });

        const consumeArray = Object.values(consumeResult)
            .sort((a, b) => new Date(a.date) - new Date(b.date));
        const custoIvaArray = Object.values(custoIvaResult)
            .sort((a, b) => new Date(a.date) - new Date(b.date));

        return { consumeArray, custoIvaArray };

    }, [filteredEnergyTypes, MONTH_NAMES]);

    const tepByLabel = useMemo(() => {
        const result = {};

        filteredEnergyTypes.forEach((item) => {
            const label = item.label;
            const unit = item.unidade?.trim();
            const consume = parseCost(item.consume);
            let tep = 0;

            if (!label || !unit || !consume || !item.periodo) return;

            const fuelConversion = fuelSpecificConversions[label.toLowerCase()];
            if (fuelConversion && fuelConversion[unit]) {
                tep = consume * fuelConversion[unit].factor;
            } else if (conversionTable[unit]) {
                tep = consume * conversionTable[unit].factor;
            } else {
                return;
            }

            if (!result[label]) result[label] = 0;
            result[label] += tep;
        });

        return Object.entries(result).map(([label, value]) => ({ name: label, value: Number(value.toFixed(2)) }));

    }, [filteredEnergyTypes]);

    const COLORS = [
        color.cor1.rgb,
        color.corPrimaria.rgb,
        color.corAmarela.rgb3,
        color.corRoxa.rgb,
        color.corLima.rgb,
        color.corVerde.rgb,
        color.corLaranja.rgb,
        color.corVermelha.rgb,
        color.corVerde.rgb,
    ];

    const randomizedColors = useMemo(() => {
        const shuffled = [];
        const aux = new Set();

        for (const c of COLORS) {
            if (!aux.has(c)) {
                aux.add(c);
                shuffled.push(c);
            }
        }

        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }

        return shuffled;
    }, []);

    const unitMap = useMemo(() => {
        return filteredEnergyTypes.reduce((acc, item) => {
            if (item.name && item.unidade) {
                acc[item.name] = item.unidade;
            }
            return acc;
        }, {});
    }, [filteredEnergyTypes]);

    const { enrichedTepByLabel, colorMap } = useMemo(() => {
        const colorMap = {};
        const enrichedTepByLabel = tepByLabel.map((item, idx) => {
            colorMap[item.name] = randomizedColors[idx % randomizedColors.length];
            return {
                ...item,
                unidade: unitMap[item.name] || '',
            };
        });

        return { enrichedTepByLabel, colorMap };
    }, [tepByLabel, unitMap, randomizedColors]);

    const CustomTooltipConsume = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px' }}>
                    <p><strong>{label}</strong></p>
                    {payload.map((entry) => {
                        const energyName = entry.name || entry.payload?.name;
                        const unit = unitMap[energyName] || entry.payload?.unidade || '';
                        const color = colorMap[energyName] || '#000';

                        return (
                            <p key={entry.dataKey} style={{ color, margin: 0 }}>
                                {energyName}: {entry.value.toFixed(2)} {unit}
                            </p>
                        );
                    })}
                </div>
            );
        }
        return null;
    };

    const CustomToolBar = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px' }}>
                    <p><strong>{label}</strong></p>
                    {payload.map((entry) => {
                        const energyName = entry.dataKey || entry.name || entry.payload?.name;
                        const unit = unitMap[energyName] || entry.payload?.unidade || '';
                        const color = entry.color || colorMap[energyName] || '#000';
                        const value = entry.value;

                        return (
                            <p key={energyName} style={{ color, margin: 0 }}>
                                {value.toFixed(2)} {unit}
                            </p>
                        );
                    })}
                </div>
            );
        }
        return null;
    };

    const CustomTooltipCustoIva = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px' }}>
                    <p><strong>{label}</strong></p>
                    {payload.map((entry) => (
                        <p key={entry.dataKey} style={{ color: colorMap[entry.name] || '#000', margin: 0 }}>
                            {entry.name}: {entry.value.toFixed(2)} €
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    ////////////////////////////////////////////////////////////////////////////////////////

    const tableStyle = {
        borderCollapse: 'collapse',
        color: color.cor1.hexa,
        textAlign: 'left',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: color.cor3.hexa,
    };

    const headerCellStyle = {
        padding: '12px 15px',
        textAlign: 'center',
        color: color.cor3.hexa,
        fontWeight: '600',
        borderBottom: '2px solid #ddd',
        backgroundColor: color.corVerde.rgb,
        textTransform: 'uppercase',
    };

    const cellStyle = {
        borderBottom: `1px solid rgb(${color.cor3.rgb})`,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '12px 15px',
        color: color.corCinza.hexa,
        lineHeight: '1.6',
        backgroundColor: color.cor3.hexa,
    };

    const rowStyle = {
        fontSize: '14px',
        backgroundColor: color.cor3.hexa,
        transition: 'background-color 0.3s ease',
    };

    const filterContainerStyle = {
        display: 'flex',
        gap: '12px',
        marginBottom: '20px',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
    };

    const filterItemStyle = {
        flex: '1 1 160px',
        display: 'flex',
        flexDirection: 'column',
    };

    const filterLabelStyle = {
        marginBottom: '4px',
        color: color.cor1.hexa,
        fontWeight: '500',
    };

    const filterSelectStyle = {
        padding: '6px 10px',
        border: `1px solid ${color.corCinza.hexa}`,
        borderRadius: '4px',
        backgroundColor: color.cor3.hexa,
        color: color.cor1.hexa,
    };

    const clean_data = () => {
        // DEEP COPY OF data_interface 
        set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
        set_dados(dados.current.info.companycode = getTokenInfo().companycode)
        //console.log(dados.current)
    }

    const fetch_entities_list = async (type) => {

        let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
        let result = []

        if (res.data !== undefined) {
            result = res.data.filter(el => parseInt(el.entity_type) === parseInt(type))
        }

        return result

    }

    const order_array = (array) => {

        return array.sort((a, b) => {
            const nameA = a.name.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // ignore upper and lowercase
            const nameB = b.name.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            // names must be equal
            return 0;
        });

    }

    useEffect(() => {
        clean_data();

        set_lang(localStorage.getItem('lang'))

        set_dados(entities_list.current = [])
        set_dados(active.current = [])

        let aux_document_state = [
            {
                id: 0,
                label: 'Em edição'
            },
            {
                id: 1,
                label: 'Aguarda aprovação'
            },
            {
                id: 2,
                label: 'Em revisão'
            },
            {
                id: 3,
                label: 'Aprovado'
            },
            {
                id: 4,
                label: 'Obsoleto'
            },
            {
                id: 5,
                label: 'Eliminado'
            }
        ]
        set_document_state_list(aux_document_state)

        const fetch_maintenance_attributes = async (type) => {

            let res = await reqGET(`${api_crud_base}/intranet/maintenance/attribute/type/${getTokenInfo().companycode}/${type}`)
            let result = []

            if (res.data !== undefined) {
                for await (let el of res.data) {
                    let aux = {
                        id: el.id,
                        name: translate(el.info.title, 'pt'),
                        unidade: el.info.unidade,
                        iva: {
                            id: el.info.iva?.id || '',
                            nome: el.info.iva?.nome || '',
                            taxa: el.info.iva?.taxa || 0,
                        }
                    }

                    result.push(aux)
                }
            }

            return result

        }

        const get_attr = async () => {

            let res_7 = await fetch_maintenance_attributes('energy_type');
            if (res_7.length > 0) {
                res_7 = order_array(res_7);

                let res_aux_7 = [];
                for await (let el of res_7) {
                    res_aux_7.push({
                        ...el,
                        label: el.name,
                        unidade: el.unidade,
                        iva: {
                            id: el.iva?.id || '',
                            nome: el.iva?.nome || '',
                            taxa: el.iva?.taxa || 0,
                        }
                    });
                }
                set_dados(energy_type.current = res_aux_7);
            }

            setLoading(false);

            return true

        }

        const fetch_id_info = async (id_serch) => {

            try {

                let res = await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
                set_dados(dados.current = res.data[0]);

                if (Array.isArray(res.data) && res.data.length > 0) {
                    if (res.data[0]?.info?.file?.pdf !== undefined && Array.isArray(res.data[0].info.file.pdf)) {
                        let aux_doc_pdf = []
                        let i = 0

                        for await (let el of res.data[0].info.file.pdf) {
                            if (aux_doc_pdf[0] === undefined)
                                aux_doc_pdf[0] = []
                            if (aux_doc_pdf[0][1] === undefined)
                                aux_doc_pdf[0][1] = []

                            // aux_doc_pdf[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
                            aux_doc_pdf[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
                        }
                        setTreeDataPDF(aux_doc_pdf)
                    }
                    if (res.data[0]?.info?.file?.editable !== undefined && Array.isArray(res.data[0].info.file.editable)) {
                        let aux_doc_editable = []
                        let i = 0

                        for await (let el of res.data[0].info.file.editable) {
                            if (aux_doc_editable[0] === undefined)
                                aux_doc_editable[0] = []
                            if (aux_doc_editable[0][1] === undefined)
                                aux_doc_editable[0][1] = []

                            // aux_doc_editable[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
                            aux_doc_editable[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
                        }
                        setTreeDataEditable(aux_doc_editable)
                    }
                    if (res.data[0]?.info?.file?.file_image !== undefined && Array.isArray(res.data[0].info.file.file_image)) {
                        let aux_doc_image = []
                        let i = 0

                        for await (let el of res.data[0].info.file.file_image) {
                            if (aux_doc_image[0] === undefined)
                                aux_doc_image[0] = []
                            if (aux_doc_image[0][1] === undefined)
                                aux_doc_image[0][1] = []

                            aux_doc_image[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
                            // aux_doc_image[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
                        }
                        setTreeDataImage(aux_doc_image)
                    }
                    if (res.data[0].info?.equipment?.id !== undefined && res.data[0].info.equipment.id !== null && res.data[0].info.equipment.id !== '') {
                        const selected = active_raw.current?.find(el => parseInt(el.id) === parseInt(res.data[0].info.equipment.id))
                        setSelectedEquipment(selected || null);
                    }
                }

                set_is_edit(true)

                get_attr()

            } catch (error) {
                console.error("Erro:", error);
            }
        }

        try {
            let test = props.location.state.operation;

            if (test === 'edit') {
                fetch_id_info(props.location.state.item.id)
            }
            else {
                get_attr()
            }

        } catch {
            clean_data()

            get_attr()

            return
        }

    }, [props, active_raw]);

    const handleAddEnergyType = async () => {
        const selected = energy_type.current.find(et => String(et.id) === String(selectedEnergyTypeId));
        if (!selected || !consumeInput || !dataInput || !periodoInput || !custoInput || !selectedEnergyTypeId) return;

        const custoParsed = parseCost(custoInput);
        const ivaRate = selected.iva?.taxa || 0;
        const custoIVA = (custoParsed * (1 + ivaRate / 100)).toFixed(2);

        const aux = {
            info: {
                energy_type: {
                    id: selected.id,
                    name: selected.name,
                    unidade: selected.unidade,
                },
                numero_documento: numeroDocumento,
                consume: consumeInput,
                custo: custoParsed.toFixed(2),
                custo_iva: custoIVA,
                data: dataInput,
                periodo: periodoInput,
                type: 'energy',
                companycode: getTokenInfo().companycode,
                iva: selected.iva
            }
        };

        try {
            let energy_id;

            if (isEditing) {
                aux.id = editItemId;
                const res = await reqPUT(`${api_crud_base}/intranet/maintenance`, aux);
                energy_id = res?.data?.id || res?.data?._id || editItemId;
            } else {
                const res = await reqPOST(`${api_crud_base}/intranet/maintenance`, aux);
                energy_id = res?.data?.id || res?.data?._id;
            }

            const newItem = {
                energy_id,
                id: selected.id,
                name: selected.name,
                unidade: selected.unidade,
                label: selected.label || selected.name,
                numero_documento: numeroDocumento,
                consume: consumeInput,
                data: dataInput,
                periodo: periodoInput,
                custo: custoParsed.toFixed(2),
                custo_iva: custoIVA,
            };

            if (isEditing) {
                setSelectedEnergyTypes(prev =>
                    prev.map(item => item.energy_id === editItemId ? newItem : item)
                );
            } else {
                setSelectedEnergyTypes(prev => [...prev, newItem]);
            }

            // Reset form
            setConsumeInput('');
            setNumeroDocumento('');
            setDataInput('');
            setPeriodoInput('');
            setCustoInput('');
            setSelectedEnergyTypeId('');
            setModalEnergyType(false);
            setIsEditing(false);
            setEditItemId(null);

        } catch (err) {
            console.error("Submission failed", err);
        }

        //setRefresh(prev => prev + 1);
        window.location.reload();
    };


    const handleEditEnergyType = (item) => {
        setNumeroDocumento(item.numero_documento || '');
        setDataInput(item.data || '');
        setEditItemId(item.energy_id || '');
        setPeriodoInput(item.periodo || '');
        setConsumeInput(item.consume || '');
        setCustoInput(item.custo || '');
        setSelectedEnergyTypeId(item.id || '');

        setIsEditing(true);
        setModalEnergyType(true);
    };

    const handleRemoveEnergyType = async (itemToRemove) => {

        const confirm = window.confirm(language[lang].remove_success);
        if (!confirm || !itemToRemove.energy_id) return;

        const aux = {
            id: itemToRemove.energy_id,
            info: {
                energy_type: {
                    id: itemToRemove.id,
                    name: itemToRemove.name,
                    unidade: itemToRemove.unidade,
                },
                numero_documento: itemToRemove.numeroDocumento,
                consume: itemToRemove.consume,
                custo: itemToRemove.custo,
                custo_iva: itemToRemove.custo_iva,
                data: itemToRemove.data,
                periodo: itemToRemove.periodo,
                type: 'energy',
                companycode: getTokenInfo().companycode,
            }
        };

        try {
            await Swal.fire({
                title: language[lang].delete_title,
                text: language[lang].delete_text,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#0095e8',
                cancelButtonColor: '#d9214e',
                confirmButtonText: language[lang].delete_confirm,
                cancelButtonText: language[lang].delete_cancel
            })
                .then(async (result) => {
                    if (result.isConfirmed) {

                        await reqDELETE(`${api_crud_base}/intranet/maintenance`, aux);

                        setSelectedEnergyTypes(prev =>
                            prev.filter(item => item.energy_id !== itemToRemove.energy_id)
                        );
                    }
                })

        } catch (error) {
            window.alert(language[lang].delete_error);
        }

        window.location.reload();

    };

    useEffect(() => {
        const fetchSubmittedEnergyTypes = async () => {
            try {
                const response = await reqGET(`${api_crud_base}/intranet/maintenance/type/${getTokenInfo().companycode}/energy`);

                let array_type_aux = []
                let array_ano_aux = []
                const formatted = response.data.map(entry => {
                    const custo = parseCost(entry.info.custo);
                    const ivaRate = entry.info.iva?.taxa || 0;
                    const custo_iva = (custo * (1 + ivaRate / 100)).toFixed(2);

                    const rawDate = entry.info.data;
                    const validDate = rawDate && !isNaN(new Date(rawDate).getTime()) ? rawDate : null;

                    let aux_1 = array_type_aux.filter(e1 => parseInt(e1.id) === parseInt(entry.info.energy_type.id))
                    if (Array.isArray(aux_1) && aux_1.length === 0) {
                        let aux_e = {
                            id: entry.info.energy_type.id,
                            name: entry.info.energy_type.name,
                            unidade: entry.info.energy_type.unidade
                        }
                        array_type_aux.push(aux_e)
                    }
                    array_type_aux = order_array(array_type_aux);

                    let aux_data = validDate.split('-')
                    let aux_2 = array_ano_aux.filter(e1 => parseInt(e1) === parseInt(aux_data[0]))
                    if (Array.isArray(aux_2) && aux_2.length === 0) {
                        array_ano_aux.push(aux_data[0])
                    }

                    return {
                        energy_id: entry.id || entry._id,
                        id: entry.info.energy_type.id,
                        numero_documento: entry.info.numero_documento,
                        name: entry.info.energy_type.name,
                        unidade: entry.info.energy_type.unidade,
                        label: entry.info.energy_type.name,
                        consume: entry.info.consume,
                        data: validDate,
                        periodo: entry.info.periodo,
                        custo: custo.toFixed(2),
                        custo_iva,
                    };
                });

                set_dados(types_actives.current = array_type_aux)
                set_dados(type_active.current = types_actives.current[0])
                set_dados(years_actives.current = array_ano_aux)
                set_dados(year_active.current = years_actives.current[0])

                setSelectedEnergyTypes(formatted);
            } catch (error) {
                console.error('Failed to fetch submitted energy types:', error);
            }
        };

        fetchSubmittedEnergyTypes();
    }, []);

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        setFilterYear(String(currentYear));
    }, []);

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">
                    <div className="container mt-4">
                        <div className="row mb-4">
                            <div className="card-title m-0 mt-4 d-flex justify-content-between align-items-center">
                                <div className="d-flex">
                                    <button
                                        type="button"
                                        className="btn rounded-pill btn-sm py-1 px-4 btn-outline-secondary me-3"
                                        onClick={() => {
                                            setShowGraphs(prev => !prev);
                                            setShowTables(prev => !prev);
                                        }}
                                    >
                                        {showGraphs ? 'Mostrar Tabelas' : 'Mostrar Gráficos'}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn rounded-pill btn-sm py-1 px-4 btn-outline-secondary me-3"
                                        onClick={() => setShowConversions(!showConversions)}
                                    >
                                        {showConversions ? 'Esconder Conversões' : 'Mostrar Conversões'}
                                    </button>
                                </div>

                                <div>
                                    <button
                                        type="button"
                                        onClick={() => setModalEnergyType(true)}
                                        className="btn rounded-pill btn-sm py-1 px-4 btn-outline-secondary"
                                    >
                                        {language[lang].adicionar_tipo_energia}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* FILTERS */}
                        <div className="row mb-4">
                            <div className='d-flex'>
                                <div className="col me-3">
                                    <label>{language[lang].ano}</label>
                                    <select
                                        className='form-select form-control mb-4 mb-lg-0 rounded-0'
                                        value={filterYear}
                                        onChange={(e) => setFilterYear(e.target.value)}
                                    >
                                        <option value="">{language[lang].field_choose}</option>
                                        {years_actives.current !== null && years_actives.current.map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col me-3">
                                    <label>{language[lang].mes}</label>
                                    <select
                                        className='form-select form-control mb-4 mb-lg-0 rounded-0'
                                        value={filterMonth}
                                        onChange={(e) => setFilterMonth(e.target.value)}
                                    >
                                        <option value="">{language[lang].field_choose}</option>
                                        {MONTH_NAMES.map((monthName, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {monthName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col me-3">
                                    <label>{language[lang].tipo_energia}</label>
                                    <select
                                        className='form-select form-control mb-4 mb-lg-0 rounded-0'
                                        value={filterEnergyType}
                                        onChange={(e) => setFilterEnergyType(e.target.value)}
                                    >
                                        <option value="">{language[lang].field_choose}</option>
                                        {types_actives.current !== null && types_actives.current.map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className='col'>
                                    <label>&nbsp;</label>
                                    <button
                                        type="button"
                                        className='btn btn-primary w-100'
                                        onClick={() => {
                                            //setFilterYear('');
                                            setFilterMonth('');
                                            setFilterEnergyType('');
                                        }}
                                    >
                                        {language[lang].field_clean}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* MODAL */}
                        {modalEnergyType && (
                            <div className="modal show" style={{ display: 'block', marginTop: '5%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">⚡ {language[lang].adicionar_tipo_energia}</h5>
                                            <button type="button" className="close" onClick={() => setModalEnergyType(false)}>
                                                &times;
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className='row mb-4'>
                                                <div className="col-3 mb-3">
                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_data}</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="date"
                                                            name="data"
                                                            className="form-control rounded-0"
                                                            placeholder={language[lang].field_data_placeholder}
                                                            value={dataInput}
                                                            onChange={(e) => setDataInput(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-3 mb-3">
                                                    <label className="fs-6 fw-bold mb-2">{language[lang].numero_documento}</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            name="numero_documento"
                                                            className="form-control rounded-0"
                                                            placeholder={language[lang].numero_documento_placeholder}
                                                            value={numeroDocumento}
                                                            onChange={(e) => setNumeroDocumento(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-3 mb-3">
                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_periodo}</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="date"
                                                            name="periodo"
                                                            className="form-control rounded-0"
                                                            placeholder={language[lang].field_periodo_placeholder}
                                                            value={periodoInput}
                                                            onChange={(e) => setPeriodoInput(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row mb-4'>
                                                <div className="col-3 mb-3">
                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].tipo_energia}</label>
                                                    <div className="input-group">
                                                        <select
                                                            className="form-control rounded-0"
                                                            value={selectedEnergyTypeId}
                                                            onChange={(e) => setSelectedEnergyTypeId(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">{language[lang].field_choose}</option>
                                                            {energy_type.current.map((type) => (
                                                                <option key={type.id} value={type.id}>
                                                                    {type.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-3 mb-3">
                                                    <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_consume}</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="number"
                                                            name="consume"
                                                            className="form-control rounded-0"
                                                            placeholder={language[lang].field_consume_placeholder}
                                                            value={consumeInput}
                                                            onChange={(e) => setConsumeInput(e.target.value)}
                                                            required
                                                        />
                                                        <span className="input-group-text rounded-0">
                                                            {
                                                                energy_type.current.find(et => String(et.id) === String(selectedEnergyTypeId))?.unidade || ''
                                                            }
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="col-3 mb-3">
                                                    <label className="fs-6 fw-bold mb-2">{language[lang].field_cost}</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            name="cost"
                                                            className="form-control rounded-0"
                                                            placeholder={language[lang].field_cost_placeholder}
                                                            value={custoInput}
                                                            onChange={(e) => setCustoInput(e.target.value)}
                                                            required
                                                        />
                                                        <span className="input-group-text rounded-0">&euro;</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-default" onClick={() => setModalEnergyType(false)}>
                                                {language[lang].close}
                                            </button>
                                            <button type="button" className="btn btn-default" onClick={handleAddEnergyType}>
                                                {language[lang].add}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Monitorização de Consumos */}
                        {showTables && (
                            <div className="row mb-5">
                                <h5 className="fw-bold mb-3">{language[lang].monitorizacao}</h5>

                                <div className={"div-table"}>
                                    <div className='table-body suppliers-list scroll table-responsive'>
                                        <table className="table suppliers-list table-hover table-bordered align-middle">
                                            <thead className="text-center align-middle">
                                                <tr>
                                                    <th className='p-3'>{language[lang].field_data}</th>
                                                    <th className='p-3'>{language[lang].numero_documento}</th>
                                                    <th className='p-3'>{language[lang].field_periodo}</th>
                                                    <th className='p-3'>{language[lang].tipo_energia}</th>
                                                    <th className='p-3'>{language[lang].field_consume}</th>
                                                    <th className='p-3'>{language[lang].field_cost}</th>
                                                    <th className='p-3'>{language[lang].field_cost_iva}</th>
                                                    <th className='p-3'>{language[lang].field_action}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredEnergyTypes.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="10" style={{ textAlign: 'center', padding: '1rem' }}>
                                                            {language[lang].no_results_found || 'Nenhum resultado encontrado'}
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    filteredEnergyTypes.map((item) => (
                                                        <tr key={item.energy_id} style={rowStyle}>
                                                            <td className='text-center' style={{fontFamily: 'monospace', fontVariantNumeric: 'tabular-nums'}}>{item.data || '—'}</td>
                                                            <td className='text-center'>{item.numero_documento || '—'}</td>
                                                            <td className='text-center' style={{fontFamily: 'monospace', fontVariantNumeric: 'tabular-nums'}}>{item.periodo || '—'}</td>
                                                            <td>{item.name || '—'}</td>
                                                            <td className='text-center'>{item.consume || '—'} {energy_type.current.find(et => String(et.id) === String(item.id))?.unidade || ''}</td>
                                                            <td className='text-end'>{item.custo ? `${item.custo} €` : '—'}</td>
                                                            <td className='text-end'>{item.custo_iva ? `${item.custo_iva} €` : '—'}</td>
                                                            <td className='text-center'>
                                                                <span>
                                                                    <button typw="button" className='me-3' onClick={() => handleEditEnergyType(item)}>
                                                                        <i className="bi bi-pencil"></i>
                                                                    </button>
                                                                </span>
                                                                <span>
                                                                    <button typw="button" onClick={() => handleRemoveEnergyType(item)}>
                                                                        <i className="bi bi-trash"></i>
                                                                    </button>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Consumo em TEP */}
                        {showTables && filteredEnergyTypes.length > 0 && (
                            <div className="row mb-5">
                                <div >
                                    <h5 className="fw-bold mb-3">{language[lang].consume_tep}</h5>
                                    <div className={"div-table"}>
                                        <div className='table-body suppliers-list table-responsive'>
                                            <table className="table suppliers-list table-hover table-bordered align-middle">
                                                <thead className="text-center align-middle">
                                                    <tr>
                                                        <th className='p-3'>{language[lang].energia}</th>
                                                        {months.map((month) => (
                                                            <React.Fragment key={month}>
                                                                <th className='p-3'>{month}</th>
                                                            </React.Fragment>
                                                        ))}
                                                        {years.map((year) => (
                                                            <React.Fragment key={`avg-${year}`}>
                                                                <th className='p-3'>{language[lang].average_consume || 'Consumo Médio'} - {year}</th>
                                                            </React.Fragment>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {types_actives.current.map((el_t) => {
                                                        const rowData = {};
                                                        const yearlyTotals = {};

                                                        months.forEach((month) => {
                                                            rowData[month] = { consumo: 0, tep: 0 };
                                                        });

                                                        years.forEach((year) => {
                                                            yearlyTotals[year] = { consumo: 0, tep: 0, count: 0 };
                                                        });

                                                        filteredEnergyTypes.forEach((item) => {
                                                            if (item.id !== el_t.id || !item.consume || !item.unidade || !item.periodo) return;

                                                            const date = new Date(item.periodo);
                                                            const month = date.toLocaleString('pt-PT', { month: 'long', year: 'numeric' });
                                                            const year = date.getFullYear();

                                                            const consume = parseCost(item.consume);
                                                            let tep = 0;

                                                            const fuelConversion = fuelSpecificConversions[item.label?.toLowerCase()];
                                                            if (fuelConversion && fuelConversion[item.unidade.trim()]) {
                                                                tep = consume * fuelConversion[item.unidade.trim()].factor;
                                                            } else if (conversionTable[item.unidade.trim()]) {
                                                                tep = consume * conversionTable[item.unidade.trim()].factor;
                                                            } else {
                                                                // return;
                                                            }

                                                            if (rowData[month]) {
                                                                rowData[month].consumo += consume;
                                                                rowData[month].tep += tep;
                                                            }

                                                            if (yearlyTotals[year]) {
                                                                yearlyTotals[year].consumo += consume;
                                                                yearlyTotals[year].tep += tep;
                                                                yearlyTotals[year].count += 1;
                                                            }
                                                        });

                                                        return (
                                                            <tr key={el_t.id}>
                                                                <td>{el_t.name}</td>
                                                                {months.map((month) => (
                                                                    <React.Fragment key={month}>
                                                                        <td className='text-center'>
                                                                            {rowData[month].consumo > 0 ? rowData[month].consumo.toFixed(2) + ' ' + el_t.unidade : ''}
                                                                            <br /><small><strong>{rowData[month].tep > 0 ? '(' + rowData[month].tep.toFixed(3) + ' tep)' : ''}</strong></small>
                                                                        </td>
                                                                    </React.Fragment>
                                                                ))}
                                                                {years.map((year) => {
                                                                    const { consumo, tep, count } = yearlyTotals[year];
                                                                    const avgConsume = count > 0 ? consumo / count : 0;
                                                                    const avgTep = count > 0 ? tep / count : 0;

                                                                    return (
                                                                        <React.Fragment key={`avg-${el_t.name}-${year}`}>
                                                                            <td className='text-center'>
                                                                                {avgConsume > 0 ? avgConsume.toFixed(2) + ' ' + el_t.unidade : ''}
                                                                                <br /><small><strong>{avgTep > 0 ? '(' + avgTep.toFixed(3) + ' tep)' : ''}</strong></small>
                                                                            </td>
                                                                        </React.Fragment>
                                                                    );
                                                                })}
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Gráficos */}
                        {showGraphs && (
                            <div className="row mb-5" style={{ marginLeft: '8px' }}>
                                <div className="col-md-6">
                                    <h5 className="fw-bold mb-3">{language[lang].consumo_mes || 'Consumo por Mês'}</h5>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <LineChart data={monthlyDataByType.consumeArray}>
                                            <XAxis dataKey="label" />
                                            <YAxis />
                                            <Tooltip content={<CustomTooltipConsume />} />
                                            <Legend />
                                            {tepByLabel.map(entry => (
                                                <Line
                                                    key={`consume-${entry.name}`}
                                                    type="monotone"
                                                    dataKey={entry.name}
                                                    stroke={colorMap[entry.name]}
                                                    strokeWidth={2}
                                                    name={entry.name}
                                                />
                                            ))}
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>

                                <div className="col-md-6">
                                    <h5 className="fw-bold mb-3">{language[lang].custo_iva_mes || 'Custo com IVA por Mês'}</h5>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <LineChart data={monthlyDataByType.custoIvaArray}>
                                            <XAxis dataKey="label" />
                                            <YAxis />
                                            <Tooltip content={<CustomTooltipCustoIva />} />
                                            <Legend />
                                            {tepByLabel.map(entry => (
                                                <Line
                                                    key={`custo-${entry.name}`}
                                                    type="monotone"
                                                    dataKey={entry.name}
                                                    stroke={colorMap[entry.name]}
                                                    strokeDasharray="4 2"
                                                    strokeWidth={2}
                                                    name={entry.name}
                                                />
                                            ))}
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        )}

                        {showGraphs && (
                            <div className="row mt-5" style={{ marginLeft: '8px' }}>
                                <div className="col-md-6">
                                    <h5 className="fw-bold mb-3">{language[lang].pie_chart_title || 'Distribuição de TEP por Tipo de Energia'}</h5>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <PieChart>
                                            <Pie
                                                data={tepByLabel}
                                                dataKey="value"
                                                nameKey="name"
                                                cx="50%"
                                                cy="50%"
                                                outerRadius={100}
                                                fill="#8884d8"
                                                label
                                            >
                                                {tepByLabel.map((entry) => (
                                                    <Cell key={`cell-${entry.name}`} fill={colorMap[entry.name]} />
                                                ))}

                                            </Pie>
                                            <Tooltip content={<CustomTooltipConsume />} />
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>

                                <div className="col-md-6">
                                    <h5 className="fw-bold mb-3">
                                        {language[lang].pie_chart_title || 'Distribuição de TEP por Tipo de Energia'}
                                    </h5>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <BarChart data={enrichedTepByLabel}>
                                            <Bar
                                                dataKey="value"
                                                nameKey="name"
                                                label
                                            >
                                                {enrichedTepByLabel.map((entry) => (
                                                    <Cell key={`cell-${entry.name}`} fill={colorMap[entry.name]} />
                                                ))}
                                            </Bar>
                                            <XAxis dataKey="name" />
                                            <YAxis />
                                            <Tooltip content={<CustomToolBar />} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        )}

                        {showConversions && (
                            <div className="row mb-5" style={{ marginLeft: '8px' }}>
                                <div className="col-4 mb-3">
                                    <h5 className="fw-bold mb-3">{language[lang].table_conversoes}</h5>
                                    <div className={"div-table"}>
                                        <div className='table-body suppliers-list table-responsive'>
                                            <table className="table suppliers-list table-hover table-bordered align-middle">
                                                <thead className="text-center align-middle">
                                                    <tr>
                                                        <th className='p-3'>{language[lang].tipo_energia}</th>
                                                        <th className='p-3'>TEP</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {energy_type.current.map((type) => {
                                                        const unit = type.unidade;
                                                        const conversion = conversionTable[unit];
                                                        if (!conversion) return null;
                                                        return (
                                                            <tr key={type.id}>
                                                                <td>{type.label}</td>
                                                                <td>
                                                                    1 {unit} = {conversion.factor} {conversion.target}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-5 mb-3">
                                    <h5 className="fw-bold mb-3">{language[lang].table_conversoes_fuel}</h5>
                                    <div className={"div-table"}>
                                        <div className='table-body suppliers-list table-responsive'>
                                            <table className="table suppliers-list table-hover table-bordered align-middle">
                                                <thead className="text-center align-middle">
                                                    <tr>
                                                        <th className='p-3'>{language[lang].tipo_energia}</th>
                                                        <th className='p-3'>t</th>
                                                        <th className='p-3'>m³</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(fuelSpecificConversions).map(([fuel, units]) => (
                                                        <tr key={fuel}>
                                                            <td>{capitalize(fuel)}</td>
                                                            <td>
                                                                {units.t ? `1 t = ${units.t.factor} ${units.t.target}` : "-"}
                                                            </td>
                                                            <td>
                                                                {units["m³"] ? `1 m³ = ${units["m³"].factor} ${units["m³"].target}` : "-"}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </main>
    )
}